import { render, staticRenderFns } from "./quillEditor.vue?vue&type=template&id=4b135495&scoped=true"
import script from "./quillEditor.vue?vue&type=script&lang=js"
export * from "./quillEditor.vue?vue&type=script&lang=js"
import style0 from "./quillEditor.vue?vue&type=style&index=0&id=4b135495&prod&lang=scss"
import style1 from "./quillEditor.vue?vue&type=style&index=1&id=4b135495&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b135495",
  null
  
)

export default component.exports